module.exports = __webpack_public_path__ + "img/avatar7.5f90842c.png";